import {
  actions,
  createAction,
  createAppDispatchHook,
  createRoutedApp,
} from '@kanda-libs/ks-frontend-services';
import { getCIDQueryParamValue } from 'hooks/useQueryParam/helpers';
import Calculator from 'pages/Calculator';
import type { FunctionComponent } from 'react';
import { AppDispatch, RootState, store } from 'store';
import AppWrapper from '../AppWrapper';
import { URLS } from './constants';

export type PageKeys = 'calculator';

const cid = getCIDQueryParamValue();

const {
  pages,
  router: { Router },
} = createRoutedApp<RootState, PageKeys>(store, {
  calculator: {
    path: URLS.calculator,
    PageComponent: Calculator,
    requiredRoles: [],
    loadingDependencies: [],
    initialDataActions: [
      createAction(actions.infoRate, {
        params: {
          cid,
        },
      }),
    ],
  },
});

const useAppDispatch = createAppDispatchHook<RootState, AppDispatch>();

export { pages, useAppDispatch };

const App: FunctionComponent = function () {
  return (
    <AppWrapper>
      <Router />
    </AppWrapper>
  );
};

export default App;
